import React, { useState } from "react";
import { ArrowLink } from "../../molecules/ArrowLink";
import { FaLinkedin } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { Navigate, useNavigate } from "react-router-dom";
import FooterForm from './footerForm'
import Modal from "react-modal";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";

export const Footer = () => {

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { data, loading, error } = useSelector((state) => state.dashboard);
  const openModal = () => {
    setModalIsOpen(true);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  };
  const customStylesForMobile = {
    content: {

      position: 'absolute',
      top: 70,
      // right: 0,
            // right: "100%",
      // right: "auto",
      bottom: 0,
      paddingTop: 0,
      marginTop: 0,
      // transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "100%",
      maxHeight: '100vh',
      // overflowY: 'none',
      backgroundColor:'transparent',
      border: 'none !importent', // Remove the default border
  


      // backgroundColor: 'red'

      // backgroundColor: 'red'
    },
  };


  const customStyles = {
    content: {
      top: '50%', // Center it vertically
      right: '0', // Align to the right
      left: 'auto', // Remove any left offset
      bottom: '0', // Make it stretch to the bottom if needed
      transform: 'translateY(-50%)', // Center it vertically
      width: '40%', // Adjust the width, you can change this percentage based on your needs
      maxWidth: '1000px', // Ensures that it doesn’t go over a certain width
      height: '100vh', // Full height
      padding: '20px', // Adjust padding if necessary
      backgroundColor: '#fff', // Ensure it has a proper background color
      overflowY: 'auto', // Allow scrolling if content overflows
      zIndex: 999, // Ensure it’s always on top
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
    document.body.style.overflow = 'auto';
    document.documentElement.style.overflow = 'auto';
  };

  const Navigate = useNavigate();
  return (
    <footer className="footer-secition">
      <div className="top-footer thmbg-nvblue mobileContainer   text-white  " style={{ zIndex: 999999 }} >
        <div className="container  pl-0 pr-0   ">
          <div className="grid footerContainer1">
            <div className="lg:col-8 md:col-5 sm:col-12 pl-0">
              <h2 className="section-title mb-2 mt-4 pl-0 font38 exploreFont">
               {data?.green_footer_title || " Explore Real-Estate Solutions for..."}
              </h2>
            </div>
            <div className="lg:col-12 md:col-7 sm:col-12 mt-0 topFooterDivContainer pl-0" >
              <div className="grid  align-items-center footerContainer2">
                <div className="  lg:col-3 md:col-4 sm:col-12  relative md:pl-0 topFooterDiv " data-aos="fade-up"
                >
                  <h3 className=" font-normal mb-4 mt-2  font28" style={{ fontFamily: 'Avenir' }} >
                    Investors
                  </h3>
                  {/* <ArrowLink
                    url="http://16.170.18.3/investor-services"
                    className="bg-arro-tranparant mt-2"
                  /> */}
                  <div className="" style={{ cursor:'pointer',height: '33px', width: '33px', border: '1px solid #fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}  onClick={()=> Navigate('/investor-services')}>
                    <i
                      className="pi pi-arrow-right"
                      style={{ fontSize: "14px", fontWeight: "800", color: '#fff' }}
                    ></i>
                  </div>
                </div>
                <div className="lg:col-3 md:col-4 sm:col-12  rightBorderTrue relative md:pl-6 font36  topFooterDiv  " data-aos="fade-up"
                >
                  <h3 className=" font-normal mb-4 mt-2 font28 " style={{ fontFamily: 'Avenir' }} >
                    Developers
                  </h3>
                  {/* <ArrowLink
                    url="http://16.170.18.3/developer-services"
                    className="bg-arro-tranparant mt-2"
                  /> */}
                  <div className="" style={{ cursor:'pointer',height: '33px', width: '33px', border: '1px solid #fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={()=> Navigate('developer-services')}>
                    <i
                      className="pi pi-arrow-right"
                      style={{ fontSize: "14px", fontWeight: "800", color: '#fff' }}
                    ></i>
                  </div>
                </div>
                <div className="lg:col-3 md:col-4 sm:col-12 rightBorderTrue relative md:pl-6 font36 topFooterDiv topFooterDivMargin  " data-aos="fade-up"
                >
                  <h3 className=" font-normal mb-4 mt-2 font28" style={{ fontFamily: 'Avenir' }} >
                    Others
                  </h3>
                  {/* <ArrowLink
                    url="http://16.170.18.3/other-services"
                    className="bg-arro-tranparant mt-2"
                  /> */}
                  <div className="" style={{cursor:'pointer', height: '33px', width: '33px', border: '1px solid #fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={()=> Navigate('/other-services')}>
                    <i
                      className="pi pi-arrow-right"
                      style={{ fontSize: "14px", fontWeight: "800", color: '#fff' }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
      .listing a:hover {
        background-color: #717171;
      }
    `}
      </style>

      <div className="borer-bottom-1 mobileContainer pt3rem  border-white thmbg-gray  text-white " >
        <div className=" container  pl-0 pr-0">
          

          <div className="container pl-0 pr-0">
  <div className="grid lg:py-4 md:py-5 sm:py-5 footerContainer">
    
    {/* Social Links Section */}
    <div className="lg:col-4 md:col-4 sm:col-12 mobilefooter pl-0">
      <h3 className="footer-heading fontAva">Social Links</h3>
      <div className="w-75 border-bottom-1"></div>
      <ul className="listing mt-4  w-75">
        <li className="mb-3">
          <a className="social-link">
            <ArrowLink url="https://www.linkedin.com/company/quantum-realty/?viewAsMember=true" iconurl="media/linked_in.png" className="bg-white" />
          </a>
        </li>
        <li className="mb-3">
          <a className="social-link">
            <ArrowLink url="http://www.youtube.com/@QuantumInfra" iconName="pi-youtube" className="bg-white" />
          </a>
        </li>
        <li className="mb-3">
          <a className="social-link">
            <ArrowLink url="https://www.instagram.com/quantumprojectinfrapvt?igsh=MTc5YW1nenRjaXpxMw%3D%3D&utm_source=qr" iconName="pi-instagram" className="bg-white" />
          </a>
        </li>
      </ul>
    </div>

    {/* Explore Quantum Section */}
    <div className="lg:col-4 md:col-4 sm:col-12 mobilefooter pl-0">
      <h3 className="footer-heading fontAva ">Explore Quantum</h3>
      <div className="w-75 border-bottom-1"></div>
      <ul className="listing mt-4 w-75">
        <li className="mb-2 "><a href="/about-us" className="footer-link ">About Us</a></li>
        {/* <li className="mb-2"><a href="/insights" className="footer-link">Insights</a></li> */}
        <li className="mb-2"><a href="/our-services" className="footer-link">Services</a></li>
        <li className="mb-2"><a href="/project-listing" className="footer-link">Projects</a></li>
      </ul>
    </div>

    {/* Know More Section */}
    <div className="lg:col-4 md:col-4 sm:col-12 mobilefooter pl-0">
      <h3 className="footer-heading fontAva">Know More</h3>
      <div className="w-75 border-bottom-1"></div>
      <ul className="listing mt-4  w-75">
        {/* <li className="mb-2"><a href="/community_impact" className="footer-link">Community Impact</a></li> */}
        <li className="mb-2"><a href="/social_responsibility" className="footer-link">Social Responsibility</a></li>
        <li className="mb-2"><a href="/careers" className="footer-link">Careers</a></li>
        <li className="mb-2"><a href="/contact-us" className="footer-link">Contact Us</a></li>
      </ul>
    </div>

    {/* Subscribe Section */}
    {/* <div className="lg:col-3 md:col-12 sm:col-12 mobilefooter pl-0 d-flex flex-column subscribeDiv ">
      <h3 className="footer-heading fontEb font3pc textAlignRight" >{data?.footer_contact_us_title||"Insights in Your Inbox"}</h3>
      <p className="footer-text w-75 textAlignRight mt-4"  >{data?.footer_contact_us_subtitle || "Stay up to date on relevant trends & latest research"}</p>
      <button onClick={openModal} className="subscribe-btn rounded-pill px-5 py-2 fontAva border-0" style={{backgroundColor:"rgb(205, 192, 139)",fontColor:'#424242',fontSize:'18px',fontWeight:'300 !important'}}>Subscribe</button>
    </div> */}

  </div>
</div>

          
        </div>
        <div className="copy-right-section border-top-1 pt-2 border-white-alpha-20" style={{ backgroundColor: '#424242' }}>
          <div className="container  pl-0">
            <div className="grid align-items-center  d-flex pl-0 " style={{}}>
              <div className="lg:col-2 md:col-3 sm:col-12 pl-0">
                <img
                  src="media/qauntumn-white.png"
                  alt=""
                  className="img-fluid pl-0 ml-0"
                />
              </div>
              <div className="lg:col-6 md:col-9 sm:col-12">
                <h4 className="text-white-800 font-normal text-center fs-15 my-0" style={{ color: '#fff', fontSize: '15px' }}>
                  {data?.footer_copyright || "Quantum ProjectInfra Pvt. Ltd., 2024 All Rights Reserved"}
                </h4>
              </div>
            </div>
          </div>
        </div>

        

      </div>
      <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStylesForMobile}
          contentLabel="Project Detail Modal"
          // className=" mobileHistoryDiv"
        >
         
          <div className="width100 align-self-center " >
            <div className="footerCross" style={{cursor:'pointer',position:"absolute"}} onClick={closeModal}>
            <button
          onClick={closeModal}
          className="btn bg-transparent border-none shadow-none p-1 cursor-pointer text-center"
        >
          <i className="pi pi-times float-right thm-red fs-25"></i>
        </button>
            </div>

          {/* <FooterForm/> */}
          <div className="container p-0  width75 " >
          <FooterForm/>
          </div>
          </div>
        </Modal>

    </footer>
  );
};
